import React, { useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { resendKeys, rekeyUnit } from "actions/Units";
import ButtonContained from "components/ButtonContained";
import Popout from 'components/Popout';

const UnitSettingsManageKeysModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const popoutAnchorRef = useRef(null);
  const unit = useSelector(state => state.units.unitObject?.unit);
  const [isPopoutOpen, setIsPopoutOpen] = useState(false);

  return (
    <div className="min-h-[300px] grid grid-cols-2 px-10 pt-4 gap-[80px]">
      <Popout
        isOpen={isPopoutOpen}
        onClose={() => setIsPopoutOpen(false)}
        anchorRef={popoutAnchorRef}
        positioning="top"
        header={false}>
        <div className="max-w-[300px] gap-3 flex flex-col pt-6">
          <p className="tw-paragraph-lg">{intl.formatMessage({ id: "pages.units.rekey" })}</p>
          <p className="tw-paragraph-reg text-[var(--color-alert)]">{intl.formatMessage({ id: "pages.units.rekey.description.warning" })}</p>
          <div className="flex gap-2 justify-start">
            <ButtonContained
              id="Unit-Settings-Manage-Keys-Rekey-Unit"
              dataCy="Unit-Settings-Manage-Keys-Rekey-Unit"
              text={intl.formatMessage({ id: "pages.units.rekey" })}
              type="default"
              onClick={() => {
                dispatch(rekeyUnit(unit.uuid, { successMessage: intl.formatMessage({ id: "notifications.success.edit" }) }))
                setIsPopoutOpen(false);
              }}
            />
            <ButtonContained
              id="Unit-Settings-Manage-Keys-Cancel-Rekey"
              dataCy="Unit-Settings-Manage-Keys-Cancel-Rekey"
              text={intl.formatMessage({ id: "comp.button.cancel" })}
              type="defaultOutline"
              onClick={() => setIsPopoutOpen(false)}
            />
          </div>
        </div>
      </Popout>

      <div className="flex flex-col justify-between">
        <div className="flex flex-col gap-4">
          <h5 className="tw-heading-5 font-semibold">{intl.formatMessage({ id: 'pages.units.rekey' })}</h5>
          <p className="tw-paragraph-reg">{intl.formatMessage({ id: `pages.units.rekey.description` })}</p>
        </div>
        <ButtonContained
          ref={popoutAnchorRef}
          id="Unit-Settings-Manage-Keys-Show-Rekey-Modal"
          dataCy="Unit-Settings-Manage-Keys-Show-Rekey-Modal"
          text={intl.formatMessage({ id: "pages.units.rekey" })}
          type="default"
          onClick={() => setIsPopoutOpen(true)}
        />
      </div>
      <div className="flex flex-col justify-between">
        <div className="flex flex-col gap-4">
          <h5 className="tw-heading-5 font-semibold">{intl.formatMessage({ id: 'pages.units.resendKeys' })}</h5>
          <p className="tw-paragraph-reg">{intl.formatMessage({ id: `pages.units.resendKeys.description` })}</p>
        </div>
        <ButtonContained
          id="Unit-Settings-Manage-Keys-Resend-Keys"
          dataCy="Unit-Settings-Manage-Keys-Resend-Keys"
          text={intl.formatMessage({ id: "pages.units.resendKeys" })}
          type="default"
          onClick={() => unit?.locks?.map((lock) => lock && dispatch(resendKeys(lock.id, { successMessage: intl.formatMessage({ id: "notifications.success.edit" }) })))}
        />
      </div>
      {/* Divider */}
      <div className="absolute top-10 bottom-10 left-1/2 w-px bg-[var(--color-gray-300)]" />
    </div>
  )
};

export default UnitSettingsManageKeysModal;